import { render, staticRenderFns } from "./ResortBannerSpace.vue?vue&type=template&id=0ca489a6&"
import script from "./ResortBannerSpace.vue?vue&type=script&lang=js&"
export * from "./ResortBannerSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports